module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tooltip":{"title":"Códigos de motivos de recusa"}},"en-US":{"tooltip":{"title":"Refusal reason codes"}}}')
  delete Component.options._Ctor
}
